(function ($) {
    $(function () {
        if ($('.js-like').length) {
            $('.js-like').PostLikes();
        }
    });
})(jQuery);

(function ($) {
    $.fn.PostLikes = function (options) {
        options = $.extend(
            {
                countElement: '.likeCount',
            },
            options,
        );

        return this.each(function () {
            var $element = $(this),
                $count = $(options.countElement),
                url = 'https://' + location.host + '/wp-admin/admin-ajax.php',
                id = $element.data('id'), // Post's ID
                nonce = $element.data('nonce'), // Nonce
                action = 'like_article',
                data = {
                    action: action,
                    post_id: id,
                    nonce: nonce,
                };

            $element.on('click', function (e) {
                e.preventDefault();
                $.getJSON(url, data, function (json) {
                    if (json && json.count) {
                        $count.text(json.count); // Update the count without page refresh
                        $('.js-like').addClass('liked'); // Add the "liked" class to the button
                    }
                });
            });
        });
    };
})(jQuery);
